const API_BASE = import.meta.env.VITE_API_URL;

// Get all conversations for the current user
export const getConversations = async (token) => {
  const response = await fetch(`${API_BASE}/api/messages/conversations`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch conversations");
  }

  return response.json();
};

// Get messages for a specific conversation
export const getMessages = async (
  conversationId,
  token,
  limit = 50,
  before = null
) => {
  const params = new URLSearchParams({ limit: limit.toString() });
  if (before) {
    params.append("before", before);
  }

  const response = await fetch(
    `${API_BASE}/api/messages/conversations/${conversationId}/messages?${params}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch messages");
  }

  return response.json();
};

// Send a message
export const sendMessage = async (conversationId, text, token) => {
  const response = await fetch(
    `${API_BASE}/api/messages/conversations/${conversationId}/messages`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ text }),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to send message");
  }

  return response.json();
};

// Create or get a direct conversation
export const createDirectConversation = async (otherUserId, token) => {
  const response = await fetch(
    `${API_BASE}/api/messages/conversations/direct`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ otherUserId }),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to create conversation");
  }

  return response.json();
};

// Get or create a team conversation
export const createTeamConversation = async (teamId, token) => {
  const response = await fetch(`${API_BASE}/api/messages/conversations/team`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ teamId }),
  });

  if (!response.ok) {
    throw new Error("Failed to create team conversation");
  }

  return response.json();
};
